<template>
<div>
		<div :class="!isLoginPage ? 'menu_trans' : '' " class="main-header main-header--one clearfix">
			<nav class="main-menu clearfix">
				<div class="main-menu__wrapper clearfix">
					<div class="main-menu__left main-menu__left--two">
						<div class="main-menu__logo">
							<a @click="handleRouter()" style="cursor: pointer; ">
								<!-- <img class="logo-dark" src="static/picture/logo-1.png" alt="">
								<img class="logo-light" src="static/picture/logo-2.png" alt=""> -->


								<img class="logo-dark" :src="getImagePath('logo-1.png')" alt="">
								<img class="logo-light" :src="getImagePath('logo-2.png')" alt="">
							</a>
						</div>
					</div>
					<div class="main-menu__main-menu-box main-menu__main-menu-box--two">
						<a href="#" class="mobile-nav__toggler"><i class="fa fa-bars"></i></a>
						<ul class="main-menu__list">
							<li class="dropdown megamenu home_li">
								<a class="main-menu__list_title" @click="clickRouter('home')">{{ $t('header.home') }}</a>
							</li>
							<li class="dropdown product_li">
								<a class="main-menu__list_title" @click="clickRouter('productList')">{{ $t('header.productCenter') }}</a>
								<ul>
									<div class="menu_two clearfix">
										<div class="menu_two_left fl">
											<div class="he_solutuli clearfix" data-num="0">
												<a target="_self" class="">
													<div class="he_solutule  fl">
														<p>{{ $t('header.softwareProducts') }}</p>
													</div>
													<div class="he_soluturi fr">
														<img src="static/picture/common/sysar1.png" class="he_img">
														<img src="static/picture/common/sysar.png" class="he_img1">
													</div>
												</a>
											</div>
											<div class="he_solutuli clearfix" data-num="1">
												<a target="_self" class="">
													<div class="he_solutule  fl">
														<p>{{ $t('header.hardwareProducts') }}</p>
													</div>
													<div class="he_soluturi fr">
														<img src="static/picture/common/sysar1.png" class="he_img">
														<img src="static/picture/common/sysar.png" class="he_img1">
													</div>
												</a>
											</div>
										</div>
										<div class="menu_two_right fl">
											<div data-num="0" class="two_right_item two_right_item_0 two_active ">
												<div class="two_item fl">
													<div class="two_item_title">
														<p>{{ $t('header.weldingSoftware') }}</p>
														<div></div>
													</div>
													<div class="two_item_content">
														<div><a	@click="clickRouter('weldCloud','productList', 'weldCloud')">{{ $t('header.intelligentWeldingCloud') }}</a></div>
														<div><a	@click="clickRouter('productSoftware','productList', 'pressureVessel')">{{ $t('header.pressureVesselSystem') }}</a></div>
														<div><a	@click="clickRouter('productSoftware','productList','steelStructure')">{{ $t('header.steelStructureSystem') }}</a></div>
														<div><a	@click="clickRouter('productSoftware','productList','weldTraining')">{{ $t('header.smartTrainingSystem') }}</a></div>
														<div><a	@click="clickRouter('productSoftware','productList','pipingSystem')">{{ $t('header.pipingWeldingSystem') }}</a></div>
													</div>
												</div>
												<div class="two_item fl">
													<div class="two_item_title clearfix">
														<p>{{ $t('header.professionalSoftware') }}</p>
														<div></div>
													</div>
													<div class="two_item_content clearfix">
														<div><a	@click="clickRouter('productSoftware','productList','weldTechnology')">{{ $t('header.weldingProcessSystem') }}</a></div>
														<div><a	@click="clickRouter('productSoftware','productList','welderInformation')">{{ $t('header.welderInfoSystem') }}</a></div>
                                                        <div><a	@click="clickRouter('productSoftware','productList','weldMaterialWarehouse')">{{ $t('header.weldingMaterialSystem') }}</a></div>
														<div><a	@click="clickRouter('productSoftware','productList','weldSeamTracking')">{{ $t('header.seamTrackingSystem') }}</a></div>
														<div><a	@click="clickRouter('productSoftware','productList','videoSystem')">{{ $t('header.videoSystem') }}</a></div>
														<div><a	@click="clickRouter('productSoftware','productList','robotSystem')">{{ $t('header.robotSystem') }}</a></div>
													</div>
												</div>
												<div class="two_item fl">
													<div class="two_item_title">
														<p>{{ $t('header.mobileSoftware') }}</p>
														<div></div>
													</div>
													<div class="two_item_content">
														<div><a	@click="clickRouter('productSoftwareApp','productList','groupControlApp')">{{ $t('header.palmGroupControl') }}</a></div>
														<div><a	@click="clickRouter('productSoftwareApp','productList','weldApp')">{{ $t('header.palmWelder') }}</a></div>
														<div><a	@click="clickRouter('productSoftwareApp','productList','operationApp')">{{ $t('header.palmOps') }}</a></div>
														<div><a	@click="clickRouter('productSoftware','productList','groupControlApplet')">{{ $t('header.wechatMiniProgram') }}</a></div>
														<div><a	@click="clickRouter('productSoftware','productList','databaseApplet')">{{ $t('header.dataLibraryMiniProgram') }}</a></div>
													</div>
												</div>
											</div>
											<div data-num="1" class="two_right_item two_right_item_1">
												<div class="two_item fl">
													<div class="two_item_title">
														<p>{{ $t('header.intelligentTerminal') }}</p>
														<div></div>
													</div>
													<div class="two_item_content">
														<div><a	@click="clickRouter('productHardware','productList','ATQ-CJ500-4G')">{{ $t('header.dataCollector') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATQ-IT070')">{{ $t('header.smartTerminal') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','AD-1900')">{{ $t('header.cloudPreTerminal') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','RWSC')">{{ $t('header.robotControlTerminal') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','weldCloud-phone')">{{ $t('header.handheldTerminal') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','weldCloud-flat')">{{ $t('header.handheldPad') }}</a></div>
													</div>
												</div>
												<div class="two_item fl">
													<div class="two_item_title">
														<p>{{ $t('header.industrialGateway') }}</p>
														<div></div>
													</div>
													<div class="two_item_content">
														<div><a	@click="clickRouter('productHardware','productList','ATQ-RS422/4G')">{{ $t('header.commController4GExt') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATQ-GW-DWL')">{{ $t('header.commController4GInt') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATQ-RS422/WF-II')">{{ $t('header.commControllerWifiExt') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATQ-GW-WF801')">{{ $t('header.commControllerWifiInt') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATQ-RS422-5G')">{{ $t('header.commController5G') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATQ-RS422-4G-IV')">{{ $t('header.commControllerMulti') }}</a></div>
													</div>
												</div>
												<div class="two_item fl">
													<div class="two_item_title clearfix">
														<p>{{ $t('header.robotGateway') }}</p>
														<div></div>
													</div>
													<div class="two_item_content clearfix">
														<div><a	@click="clickRouter('productHardware','productList','ATR-485-Ⅱ')">{{ $t('header.robotCommATR485') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATR-CAN-Ⅱ')">{{ $t('header.robotCommATRCAN') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATR-CANOPEN')">{{ $t('header.robotCommATRCANOPEN') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATR-DEV-Ⅳ')">{{ $t('header.robotCommATRDEV') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATR-EtherCAT')">{{ $t('header.robotCommATREtherCAT') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATR-PROFINET')">{{ $t('header.robotCommATRPROFINET') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATR-GATEWAY')">{{ $t('header.robotGatewayDevice') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATR-GW-EIP')">{{ $t('header.robotGatewayEIP') }}</a></div>
													</div>
												</div>
											
												<div class="two_item fl">
													<div class="two_item_title">
														<p>{{ $t('header.otherDevices') }}</p>
														<div></div>
													</div>
													<div class="two_item_content">
														<div><a	@click="clickRouter('productHardware','productList','ATQ-SR')">{{ $t('header.handheldProcessTerminal') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATQ-GFS50')">{{ $t('header.gasFlowMeter') }}</a></div>
														<div><a	@click="clickRouter('productHardware','productList','ATQ-NFC')">{{ $t('header.cardReader') }}</a></div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</ul>
							</li>
							<li class="dropdown solution_li">
								<a class="main-menu__list_title" @click="clickRouter('solutionList')">{{ $t('header.solution') }}</a>
							</li>
							<li class="dropdown case_li">
								<a class="main-menu__list_title" @click="clickRouter('caseList')">{{ $t('header.caseStudies') }}</a>
								<ul>
									<div class="case_item ">
										<div class="two_item fl">
											<div class="two_item_title">
												<p>{{ $t('header.pressureVesselIndustry') }}</p>
												<div></div>
											</div>
											<div class="two_item_content">
												<div><a	@click="clickRouter('caseList', 'pressureVessel', 'pressure2' )">{{ $t('header.shandongPressureClient') }}</a></div>
												<div><a	@click="clickRouter('caseList', 'pressureVessel', 'pressure1')">{{ $t('header.liaoningDalianClient') }}</a></div>
											</div>
										</div>
										<div class="two_item fl">
											<div class="two_item_title clearfix">
												<p>{{ $t('header.machineryIndustry') }}</p>
												<div></div>
											</div>
											<div class="two_item_content clearfix">
												<div><a	@click="clickRouter('caseList', 'mechanical', 'mechanical1' )">{{ $t('header.guangdongMachineryClient') }}</a></div>
											</div>
										</div>
										<div class="two_item fl">
											<div class="two_item_title">
												<p>{{ $t('header.trainingIndustry') }}</p>
												<div></div>
											</div>
											<div class="two_item_content">
												<div><a @click="clickRouter('caseList', 'weldingTraining', 'weldingTraining1')">{{ $t('header.shandongNuclearTraining') }}</a></div>
												<div><a	@click="clickRouter('caseList', 'weldingTraining', 'weldingTraining2')">{{ $t('header.guangxiWeldingSchool') }}</a></div>
											</div>
										</div>
										<div class="two_item fl">
											<div class="two_item_title">
												<p>{{ $t('header.coalMachineIndustry') }}</p>
												<div></div>
											</div>
											<div class="two_item_content">
												<div><a	@click="clickRouter('caseList', 'coalMachine', 'coalMachine1')">{{ $t('header.henanCoalClient') }}</a></div>
												<div><a	@click="clickRouter('caseList', 'coalMachine', 'coalMachine2')">{{ $t('header.guizhouCoalClient') }}</a></div>
											</div>
										</div>
										<div class="two_item fl">
											<div class="two_item_title">
												<p>{{ $t('header.steelStructureIndustry') }}</p>
												<div></div>
											</div>
											<div class="two_item_content">
												<div><a	@click="clickRouter('caseList', 'steelStructure', 'steelStructure1')">{{ $t('header.jiangsuSteelClient') }}</a></div>
											</div>
										</div>
										<div class="two_item fl">
											<div class="two_item_title">
												<p>{{ $t('header.pipingIndustry') }}</p>
												<div></div>
											</div>
											<div class="two_item_content">
												<div><a	@click="clickRouter('caseList', 'piping', 'piping1')">{{ $t('header.hebeiPipingClient') }}</a></div>
												<div><a	@click="clickRouter('caseList', 'piping', 'piping2')">{{ $t('header.sichuanPipingClient') }}</a></div>
											</div>
										</div>
										<div class="two_item fl">
											<div class="two_item_title">
												<p>{{ $t('header.shipbuildingIndustry') }}</p>
												<div></div>
											</div>
											<div class="two_item_content">
												<div><a	@click="clickRouter('caseList', 'ship', 'ship1')">{{ $t('header.dalianShipClient') }}</a></div>
											</div>
										</div>
									</div>
								</ul>
							</li>
							<li class="dropdown news_li">
								<a class="main-menu__list_title" @click="clickRouter('news')">{{ $t('header.news') }}</a>
							</li>

							<li class="dropdown menu_resource resource_li">
								<a class="main-menu__list_title" @click="clickRouter('resourceList')">{{ $t('header.resourceCenter') }}</a>
								<ul>
									<div class="resource_item ">
										<div class="two_item fl">
											<div class="two_item_title">
												<a @click="clickRouter('resourceList')">
													<p>{{ $t('header.downloads') }}</p>
												</a>
											</div>
										</div>
										<div class="two_item fl">
											<div class="two_item_title">
												<a @click="clickRouter('industry')">
													<p>{{ $t('header.industryStandards') }}</p>
												</a>
											</div>
										</div>
										<div class="two_item fl">
											<div class="two_item_title clearfix">
												<a @click="clickRouter('weldCertificate')"><p>{{ $t('header.welderTips') }}</p></a>
											</div>
										</div>
									</div>
								</ul>
							</li>
							<li class="dropdown video_li">
								<a class="main-menu__list_title" @click="clickRouter('videoList')"><p>{{ $t('header.videoData') }}</p></a>
							</li>
							<li class="dropdown about_li">
								<a class="main-menu__list_title" @click="clickRouter('about')">{{ $t('header.contactUs') }}</a>
							</li>
						</ul>
					</div>
					<div class="main-menu__right">
						<div class="main-menu__search-call">
							<div>
								<el-tooltip :manual="true"  v-model="homeShow" effect="dark"  placement="bottom" >
									<div slot="content" style="font-size: 20px;">{{ $t('header.officialWebsite') }}</div>
									<a @mouseenter="mouseenterHome"  @mouseleave="mouseleaveHome" class="main-menu__search search-toggler " target="_blank" :href="official">
										<i class="el-icon-s-home el-icon-menu_bg" ></i> 
									</a>
								</el-tooltip>
							</div>
							<div style="margin-left: 5px;" v-if="lang == 'zh_CN' && !isLoginPage">
								<el-tooltip :manual="true"  v-model="systemShow"  effect="dark"  placement="bottom" >
									<div slot="content" style="font-size: 20px;">{{ $t('header.systemExperience') }}</div>
									<a  @mouseenter="mouseenterSystem"  @mouseleave="mouseleaveSystem" class="main-menu__search search-toggler "  @click="handleSystem">
										<i class="el-icon-menu el-icon-menu_bg" ></i> 
									</a>
								</el-tooltip>
							</div>
							<div style="margin-left: 5px;">
								<el-tooltip :manual="true"  v-model="registerShow"  effect="dark"  placement="bottom" >
									<div slot="content" style="font-size: 20px;">{{ $t('header.businessRegistration') }}</div>
									<a  @mouseenter="mouseenterRegister"  @mouseleave="mouseleaveRegister" class="main-menu__search search-toggler "  @click="handleRegister">
										<i class="el-icon-edit-outline el-icon-menu_bg" ></i> 
									</a>
								</el-tooltip>
							</div>
							<div style="margin-left: 5px;" >
								<el-dropdown size="medium"  @command="handleSetLanguage">
									<span class="languang_title">
										 {{languang}}  <i class="el-icon-arrow-down el-icon-menu_bg" ></i> 
									</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="zh_CN" >简体中文</el-dropdown-item>
									<el-dropdown-item command="en_US" >English</el-dropdown-item>
									
								</el-dropdown-menu>
								</el-dropdown>
							</div>

							<div class="main-menu__search-box" style="color: #ffa800;">
								<el-tooltip :manual="true"  v-model="menuShowV"  effect="dark"  placement="bottom">
									<div slot="content" style="font-size: 20px;">{{ $t('header.aotaiCloudV1') }}</div>
									<a @mouseenter="mouseenterMenuV"  @mouseleave="mouseleaveMenuV" class="main-menu__search search-toggler main-menu__land" target="_blank" :href="login1" >{{ $t('header.loginV1') }}</a>
								</el-tooltip>
							</div>
							<div class="main-menu__search-box" style="color: #ffa800;">
								<el-tooltip :manual="true"  v-model="menuShow"  effect="dark"  placement="bottom">
									<div slot="content" style="font-size: 20px;">{{ $t('header.aotaiCloudV2') }}</div>
									<a  @mouseenter="mouseenterMenu"  @mouseleave="mouseleaveMenu" class="main-menu__search search-toggler main-menu__land" target="_blank" :href="login2" >
										{{ $t('header.loginV2') }}
									</a>
								</el-tooltip>
							</div>
						</div>
						
					</div>
				</div>
			</nav>
		</div>

	</div>
</template>
<script>
	export default {
		name: 'header-aotai',
		data() {
			return {
				homeShow:false,
				systemShow: false,
				menuShow: false,
				menuShowV: false,
				registerShow: false,

				languang: '简体中文',
				lang: localStorage.getItem('lang'),

				login1: window._address_env_?.login1 || '',
				login2: window._address_env_?.login2 || '',
				official: window._address_env_?.official || '',
			}
		},
		created() {
			this.defaultLanguageValue()
		},
		computed: {
			// 自动响应路由变化
			isLoginPage() {
				return this.$route.path.includes('/login') || this.$route.path.includes('/system')
			}
		},
		watch: {
			 isLoginPage: {
				immediate: true,    // ← 加这一行，首次加载也触发
				handler(val) {
					if (val) {
						$(window).off('scroll', this._onScroll)
					} else {
						this.$nextTick(() => this._bindScroll())
					}
				}
			}
		},
		mounted() {

			$(".main-menu__list li").mouseenter(function(e) {
				// 显示2级菜单
				$(this).addClass("menu_display")
			}).mouseleave(function() {
				// 隐藏2级菜单
				$(this).removeClass('menu_display')
			})

			$(".he_solutuli").mouseenter(function(e) {
				// 2级菜单图标显隐
				$('.nav_active').removeClass('nav_active');
				$(this).addClass("nav_active");
				// 展示3级菜单
				$('.two_active').removeClass('two_active');
				var param = 'two_right_item_' + $(this).data('num')
				$('.' + param).addClass('two_active');


			}).mouseleave(function() {})


			// if(!this.isLoginPage) {
			// 	$(document).ready(function() {
			// 		var scroll_start = 0;
			// 		var change_color = $('.main-header');
			// 		var offset = change_color.offset();
			// 		if (change_color.length) {
			// 			$(document).scroll(function() {
			// 				// console.log("菜单切换")
			// 				scroll_start = $(this).scrollTop();
			// 				if (scroll_start > 0) {
			// 					$(".main-header").removeClass("menu_trans");
			// 				} else {
			// 					$(".main-header").addClass("menu_trans");
			// 				}

			// 			});
			// 		}
					
			// 	})
			// }
			 if (!this.isLoginPage) this._bindScroll()
			$('.main-header').css("position", "fixed");
		},
		beforeDestroy() {
			$(window).off('scroll', this._onScroll)
		},
		methods: {
			_bindScroll() {
				$(window).off('scroll', this._onScroll)   // 先解绑，防止重复绑定
				this._onScroll = () => {
					if (this.isLoginPage) return
					const scrollTop = $(window).scrollTop()
					if (scrollTop > 0) {
						$(".main-header").removeClass("menu_trans");
					} else {
						$(".main-header").addClass("menu_trans");
					}
				}
				$(window).on('scroll', this._onScroll)
			},
			// 路由跳转
			clickRouter(val, classification, type) {
				// val: 路径， classification：分类-应用案例展示哪一个  type：参数
				if (val == "caseList") { // 应用案例
					var url = val
					this.$router.push({
						path: url,
						query: {
							classification: classification,
							type: type
						}
					});
				} else if (classification == 'productList' || classification == 'solutionList') { // 产品中心 || 解决方案
					if(type) {
						this.$router.push({
							path: val,
							query: {
								type: type
							}
						});
					} else {
							// 使用国际化消息
						this.$message.warning(this.$t('header.tempUnavailable'));
					}
				
				} else {
					var url = val
					this.$router.push({
						path: url
					});
				}
				// 关闭二级菜单
				$('.menu_display').removeClass('menu_display');
			},
			handleRouter() {
				const url =  window._address_env_.official  //'http://www.aotaidianqi.com/'; // 确保正确的协议，例如 'http://' 或 'https://'
				window.open(url, '_blank');
			},
			handleSystem() {
				const targetRoute = this.$router.resolve({ path: '/login' });
   				 window.open(targetRoute.href, '_blank');

			},
			// 注册
			handleRegister() {
				const url = 'http://60.208.18.107:21018/operation/businessRegister/BusinessRegisterForm'; // 确保正确的协议，例如 'http://' 或 'https://'
				window.open(url, '_blank');
			},
			mouseleaveRegister() {
				this.registerShow = false
			},
			mouseenterRegister() {
				this.registerShow = true
			},
			// 官网
			mouseenterHome() {
				this.homeShow = true
			},
			mouseleaveHome() {
				this.homeShow = false
			},
			// 系统体验控制显示
			mouseenterSystem() {
				this.systemShow = true
			},
			mouseleaveSystem() {
				this.systemShow = false
			},
			// 焊接云图标控制 
			mouseenterMenu() {
				this.menuShow = true
				console.log("进入")
			},  
			mouseleaveMenu() {
				this.menuShow = false
				console.log("移出")
			},

				// 焊接云图标控制 
			mouseenterMenuV() {
				this.menuShowV = true
				console.log("进入")
			},  
			mouseleaveMenuV() {
				this.menuShowV = false
				console.log("移出")
			},

			 defaultLanguageValue(){
				this.lang = this.$i18n.locale
				var lang = this.$i18n.locale
				if(lang == 'en_US'){
					this.languang = "English"
				}else if(lang=='ru_RU'){
					this.languang = "русский"
				}else{
					this.languang = "简体中文"
				}
			},

			 handleSetLanguage(lang) {
				console.log("切换语言", lang)
				// 保存到 localStorage
				localStorage.setItem('locale', lang);
				
				// 直接切换 i18n locale（核心改动）
				this.$i18n.locale = lang;
				this.lang = lang;

				 // 更新显示的语言名称
				const langNames = {
					'en_US': 'English',
					'ru_RU': 'русский',
					'zh_CN': '简体中文'
				};
				this.languang = langNames[lang] || '简体中文';
				location.reload();

      		},

			getImagePath(path) {
				var  url = ""
				if(this.$i18n.locale == 'zh_CN') {
					url = 'static/picture/' + path
				} else if( this.$i18n.locale == 'en_US') {
					url = 'static/picture/en/' + path
				} else if( this.$i18n.locale == 'ru_RU') {
					url = 'static/picture/ru/' + path
				} else {
					url = 'static/picture/' + path
				}
				return url;
			}


			
		}
	}
</script>
<style scoped>
	@import '../../../../public/static/css/aotai-header.css';

	.main-menu .main-menu__list>li+li,
		.stricky-header .main-menu__list>li+li {
			margin-left: 45px;
		}

		.main-header--one{
			padding: 0 40px;
		}

	@media (max-width: 1680px) {

		.main-menu .main-menu__list>li+li,
		.stricky-header .main-menu__list>li+li {
			margin-left: 18px;
		}

		.main-menu__logo {
			margin-right: 50px;
		}
	}
	@media (max-width: 1500px) {
		.main-menu__list_title {
			font-size: var(--font-size-16)  !important;
		}
	}
	@media (max-width: 1420px) {
		.main-menu__list_title {
			font-size: var(--font-size-14)  !important;
		}

		.main-menu__logo {
			margin-right: 10px;
		}

		.main-menu__right {
			padding-top: 15px!important; 
		}
		.main-header--one {
			padding: 0 10px;
		}
	}
	@media (max-width: 900px) {
		.main-menu__right {
			display: none;
		}
		.mobile-nav__toggler {
			display: none;

		}
	}
	@media only screen and (min-width: 1400px) and (max-width: 1419px) {
		.main-menu__right {
			padding-top: 25px!important; 
		}
	}
	@media (max-width: 1200px) {
		.main-menu__list_title {
			font-size: var(--font-size-14)  !important;
		}

		.main-menu__logo {
			margin-right: 10px;
		}

		.main-menu__right {
			padding-top: 20px!important; 
		}
		.main-header--one {
			padding: 0 10px;
		}
	}
	@media only screen and (min-width: 1200px) and (max-width: 1399px) {
		.main-menu .mobile-nav__toggler {
			display: none;
		}
		.main-menu__logo {
			margin-right: 0px;
		}
		.main-menu__logo img{
			height: 35px !important;
		}
		.main-menu .main-menu__list, .main-menu .main-menu__list ul, .stricky-header .main-menu__list, .stricky-header .main-menu__list ul {
			display: flex;
		}
		.main-menu .main-menu__list>li {
			padding-top: 28px;
			padding-bottom: 30px;
		}
	}
	@media only screen and (min-width: 1100px) and (max-width: 1199px) {
		.main-menu .mobile-nav__toggler {
			display: none;
		}
		/* 这里隐藏了包含logo的整个左侧区域  */
		.main-menu__left {
			display: none;
		}
		.main-menu__logo {
			margin-right: 0px;
		}
		.main-menu__logo img{
			height: 35px !important;
		}
		.main-menu .main-menu__list, .main-menu .main-menu__list ul, .stricky-header .main-menu__list, .stricky-header .main-menu__list ul {
			display: flex;
		}
		.main-menu .main-menu__list>li {
			padding-top: 28px;
			padding-bottom: 30px;
		}
	}

	@media only screen and (min-width: 900px) and (max-width: 1099px) {
		.main-menu .mobile-nav__toggler {
			display: none;
		}
		/* 这里隐藏了包含logo的整个左侧区域  */
		.main-menu__left {
			display: none;
		}
		.main-menu .main-menu__list, .main-menu .main-menu__list ul, .stricky-header .main-menu__list, .stricky-header .main-menu__list ul {
			display: flex;
		}
		.main-menu .main-menu__list>li {
			padding-top: 28px;
			padding-bottom: 30px;
		}
	}

	@media only screen and (min-width: 798px) and (max-width: 899px) {
		.main-menu .mobile-nav__toggler {
			display: none;
		}
		/* 这里隐藏了包含logo的整个左侧区域  */
		.main-menu__left {
			display: none;
		}
		.main-menu .main-menu__list, .main-menu .main-menu__list ul, .stricky-header .main-menu__list, .stricky-header .main-menu__list ul {
			display: flex;
		}
		.main-menu .main-menu__list>li {
			padding-top: 28px;
			padding-bottom: 30px;
		}
	}

	
	/* 图标位置 */
	.main-menu__logo {
		padding-top: 30px;
	
	}

	.main-menu__logo img {
		height: 60px;
	}

	.main-menu .main-menu__list>li>a {
		font-size: var(--font-size-20) ;
	}

	.menu_trans {
		background: transparent;
	}

	/* 菜单颜色 */
	.menu_trans .main-menu__list_title {
		color: var(--notech-white) !important;
	}

	.menu_trans .main-menu__list_title:hover {
		color: var(--notech-white)
	}

	/* 图标 */
	.menu_trans .mmr_img-dark {
		display: block !important;
	}

	.menu_trans .mmr_img-light {
		display: none !important;
	}

	/* 图标 */
	.mmr_img-dark {
		display: none;
	}

	.mmr_img-light {
		display: block;
	}


	.menu_trans .main-menu__right .main-menu__call-number a {
		color: var(--notech-white)
	}
	/* .menu_trans .main-menu__search {
		color: var(--notech-white) !important;
	} */
	/* 系统体验入口 */
	.menu_trans .el-icon-menu_bg {
		color: var(--notech-white) !important;
	}

	/* 官网入口 */
		/* 图标 */
		.menu_trans .logo-dark {
			display: none !important;
		}

		.menu_trans .logo-light {
			display: block !important;
		}



		.languang_title {
			display: inline-block;
			padding: 1px 10px;
			border-width: 1px;
			border-style: solid;
			border-radius: 5px;
			border-color: var(--notech-gray);
			color: var(--notech-gray) !important;
			font-size: 16px;
		}

		.menu_trans .languang_title{
			color: var(--notech-white) !important;
			border-color: var(--notech-white);
		}

	.main-menu__search-box:before {
		width: 0px;
	}

	.main-header {
		box-shadow: 0px 2px 4px 0px rgba(19, 17, 67, 0.13);
	}

	.main-menu .main-menu__list li ul {
		position: fixed;
		width: 100%;
		top: 100px;
		left: 0;
		background: #fff;

		transition: top 0.36s;
		height: 459px;
		margin-top: 0px;
		margin-bottom: 0px;

		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		-webkit-box-pack: start;
		-ms-flex-pack: start;
		justify-content: flex-start;
		-webkit-box-align: start;
		-ms-flex-align: start;
		align-items: flex-start;
		z-index: 99;
		-webkit-box-shadow: 0px 0px 65px 0px rgba(0, 0, 0, 0.1);
		box-shadow: 0px 0px 65px 0px rgba(0, 0, 0, 0.1);
	}
	.main-menu {
		padding: 0;
	}
	.main-menu__main-menu-box {
		cursor: pointer;
	}
	.main-menu__list .two_active {
		display: block !important;
	}

	.main-menu__list a:hover {
		color: var(--notech-base);
	}
	.clearfix {
		zoom: 1;
	}
	.fl {
		float: left;
	}

	/* 二级菜单 */
	.menu_two {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.main-menu .main-menu__list .menu_display:hover>ul,
	.stricky-header .main-menu__list .menu_display:hover>ul {
		opacity: 1;
		visibility: visible;
	}

	.menu_two_left {
		width: 260px;
		height: 100%;
		position: relative;
		background: #fff;
		padding-top: 55px;
		padding-bottom: 55px;
		padding-left: 3.5%;
		padding-right: 64px;
	}


	.menu_two_right {
		background: var(--notech-extra);
		width: calc(100% - 260px);
		height: 100%;
		padding-top: 55px;
		padding-bottom: 55px;
		padding-right: 4%;
		padding-left: 37px;
	}

	/* 左侧菜单 */
	.he_solutu {
		width: 100%;
	}

	.he_solutuli {
		margin-bottom: 23px;
		padding-bottom: 13px;
	}

	.he_solutule {
		width: calc(100% - 20px);
		padding-right: 10px;
		color: var(--notech-black);
	}

	.he_solutule p {
		font-size: var(--font-size-20);
	}

	.he_soluturi {
		width: 20px;

	}

	.fr {
		float: right;
	}

	.he_soluturi img {
		width: 6px;
		height: inherit !important;
		transition: all 0.36s;
		position: relative;
		top: 0;
		left: 0;
	}

	/* 隐藏蓝色 */
	.he_soluturi .he_img1 {
		top: 12px;
		display: none;
		/* opacity: 0; */
	}

	.he_solutuli.nav_active .he_soluturi .he_img {
		/* opacity: 0; */
		display: none;
	}

	.he_solutuli.nav_active .he_soluturi .he_img1 {
		/* opacity: 1; */
		display: block;
	}

	.he_solutuli.nav_active .he_solutule {
		color: var(--notech-base);
	}

	.menu-two-level_right {
		width: calc(100% - 400px);
		padding-right: 4%;
		padding-left: 37px;
		background: var(--notech-base);

	}
	.two_item {
		/* width: 33%; */
		width: auto !important;
		height: 100%;
		padding: 0 20px;
		text-align: left;
	}
	.two_item_title {
		font-size: var(--font-size-20);
		line-height: 1.75;
		color: var(--notech-black);
	}

	.two_item_title div {
		margin-top: 12px;
		width: 40px;
		height: 2px;
		background: var(--notech-base);
	}

	.two_item ul {
		width: 100%;
		height: 100%;
	}

	.two_item_content {
		margin-top: 22px;
		font-size: var(--font-size-16);
		line-height: 36px !important;
		color: var(--notech-gray) !important;
		transition: all 0.36s;
	}

	.two_item:not(:last-child) {
		border-right: 1px solid rgba(221, 221, 221, 0.4);
	}


	.menu_two_right .two_right_item {
		display: none;
	}

	/* 案例 */
	.main-menu__list .case_item {
		margin: 0 auto;
		padding-top: 55px;
		padding-bottom: 55px;
	}

	.menu_resource ul {
		height: 150px !important;
		padding-top: 50px !important;
		margin-top: 0px;
		padding-bottom: 50px !important;
		margin-bottom: 0px;
	}

	.main-menu__list .resource_item {
		font-size: var(--font-size-16);
		margin: 0 auto;
	}

	.two_item_content .about {
		display: -webkit-box;
	}

	.two_item_content .about .icon {
		margin-right: 20px;
	}

	.main-menu__right {
		padding: 0;
		padding-top: 35px;
	}
	
	.main-menu__search {
		cursor: pointer;
		font-size: 25px;
		font-weight: bold;
	}
	.main-menu__land {
		border-radius: 5px;
		padding: 5px;
		color: #fff;
		background-color: var(--notech-base);
		font-size: 16px;
	}
	.main-menu__search-box {
		margin-left: 8px;
	}
	.el-tooltip-menu {
		font-size: 20px;
	}
	.el-icon-menu_bg {
		color: var(--notech-base);
	}
</style>
